import { LocalizationTabScreen } from "@/features/staff/localization";

export default function LocalizationPage() {
  return <LocalizationTabScreen />;
}
